import { useState, useEffect } from "react"
import { ISexo, SexoKeys } from "../../../../../../../application/models"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { Autocomplete, Grid, TextField } from "@mui/material"
import { sexoKeyToLabel } from "../../../detalhes-do-projeto/filtros/sexo"
// Icon
import { useAppSelector } from "../../../../../../hooks/store-hooks"

export const RecorteSexo = () => {
    // Redux State
    const { editRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)

    // Local State
    const [selectedSexo, setSelectedSexo] = useState<ISexo[]>([])

    // Hooks
    const { syncFilterWithForm, removeFilterFromForm } = useRecortesExtracaoService()

    // Effects
    useEffect(() => {
        const sexosSelecionados = editRecorteExtracaoForm.fields.Filtros?.sexo || [];

        if (sexosSelecionados.length > 0) {
            setSelectedSexo(sexosSelecionados);
        } else {
            setSelectedSexo([]);
        }
    }, [editRecorteExtracaoForm.fields.Filtros?.sexo]);

    // Filter options to show only non-selected genders
    const filteredSexo = SexoKeys.filter((sexo: ISexo) =>
        !selectedSexo.includes(sexo)
    );

    const handleSexoSelectionChange = (value: ISexo[]) => {
        setSelectedSexo(value);

        if (value.length > 0) {
            syncFilterWithForm({
                filtro: 'sexo',
                value: value,
                formType: 'edit'
            });
        } else {
            removeFilterFromForm({
                filtro: 'sexo',
                formType: 'edit'
            });
        }
    }

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredSexo}
                    value={selectedSexo}
                    getOptionLabel={(option) => sexoKeyToLabel(option).toUpperCase()}
                    sx={{
                        px: 2
                    }}
                    onChange={(event, value) => {
                        handleSexoSelectionChange(value);
                    }}
                    noOptionsText='Nenhum sexo encontrado'
                    filterSelectedOptions={true}
                    disableCloseOnSelect
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Opções"
                        />
                    )}
                />
            </Grid>
        </>
    )
}